import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useReservationStateStream } from "@bw/shared/hooks";

import { queryKeys } from "../../../common/query/queryClient";

/** Reconcile every player cache that can expose reservation occupancy/status. */
export function useReservationStateSync(facilityId: string | undefined): void {
  const queryClient = useQueryClient();
  const reconcile = useCallback(async () => {
    if (!facilityId) return;
    const invalidate = (queryKey: readonly unknown[]) =>
      queryClient.invalidateQueries({ queryKey }, { throwOnError: true });
    await invalidate(
      queryKeys.booking.availability(facilityId, "").slice(0, 3),
    );
    void Promise.allSettled([
      queryClient.invalidateQueries({
        queryKey: queryKeys.booking.courts(facilityId),
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.booking.operatingHours(facilityId),
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.booking.pricing(facilityId),
      }),
      queryClient.invalidateQueries({
        queryKey: queryKeys.booking.facility(facilityId),
      }),
    ]);
  }, [facilityId, queryClient]);

  useReservationStateStream({
    facilityId: facilityId ?? "",
    revision: 0,
    onReconcile: reconcile,
    enabled: Boolean(facilityId),
  });
}
